import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../store';
import { SelectableItemType, SelectedItemIdentifier } from './types';

const getSelectedItemIdentifiersDuringRenamingMode = createSelector(
  (state: RootState) => state.panelData.renameLayoutComponentsPanel,
  (state: RootState) => state.layout.trussEnvelopes,
  (panel, trussEnvelopes): SelectedItemIdentifier[] => {
    if (!panel.open) return [];

    const targetedComponentDesignGuids = new Set(panel.componentDesignGuids);

    return Object.values(trussEnvelopes)
      .filter(
        (envelope) => envelope.componentDesignGuid && targetedComponentDesignGuids.has(envelope.componentDesignGuid),
      )
      .map(({ guid }) => ({ type: 'trussEnvelope', guid }));
  },
);

export const getSelectedItemIdentifiers = createSelector(
  (state: RootState) => state.selections.selectedItems,

  getSelectedItemIdentifiersDuringRenamingMode,
  (state: RootState) => state.panelData.renameLayoutComponentsPanel,

  (selectedItems, selectedItemsDuringRenamingMode, renameLayoutComponentsPanel) => {
    return renameLayoutComponentsPanel.open ? selectedItemsDuringRenamingMode : selectedItems;
  },
);

export const getFirstSelectedItemIdentifierOrNull = createSelector(
  getSelectedItemIdentifiers,
  (selectedItems): SelectedItemIdentifier | null => {
    if (selectedItems.length > 0) {
      return selectedItems[0];
    }

    return null;
  },
);

export const getSingleSelectedItemIdentifierOrNull = createSelector(
  getSelectedItemIdentifiers,
  (selectedItems): SelectedItemIdentifier | null => {
    if (selectedItems.length === 1) {
      return selectedItems[0];
    }

    return null;
  },
);

export function areAnyItemsOfTypeSelected(type: SelectableItemType, state: RootState) {
  const identifiers = getSelectedItemIdentifiers(state);
  return identifiers.some((identifier) => identifier.type === type);
}
